require('./countDown')
require('./countUp')
require('./pathInstall')
// require('./linkSymbol')
// require('./progress')
// require('./button')
// require('./blockies')
// require('./image')
// require('./pagination')



// WEBPACK FOOTER //
// ./src/plugins/components/index.js